import { api } from "@/builders/axios";

const get = function (id: number) {
  return api.get<{
    title: string;
  }>(`courses/module/chapter/${id}`);
};

const put = function (id: number, data: { title: string }) {
  return api.put(`/courses/module/chapter/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/courses/module/chapter/${id}`);
};

export const id = {
  get,
  put,
  del,
};
